import React from 'react';
import { BetType, OVAL_TABLE_DATA } from '../../enums/tableNumbers';
import { uuid } from '../../helpers/uuid';

export const PieChartWrapper = ({ statistics, isActive, isRemove }) => {
  return (
    <div className={`pie-chart-wrp ${isActive ? 'active' : ''} ${isRemove ? 'remove' : ''}`}>
      <div className='pie-chart-number-wrp'>
        {OVAL_TABLE_DATA.map((item) => (
          <div className='pie-chart-number' data={BetType[`StraightUp_${item.value}`]} key={uuid()}>
            <p className='pie-chart-text' data={BetType[`StraightUp_${item.value}`]}>
              {item.value}
            </p>
          </div>
        ))}
      </div>
      <div className='pie-chart-border-wrp'>
        <div className='pie-chart-inner-wrp'>
          <div className='pie-chart-number-wrp transparent-stat'>
            {OVAL_TABLE_DATA.map((item) => {
              return (
                <div className='pie-chart-number' key={uuid()}>
                  <div
                    style={{ height: `${statistics?.combinationStatistic[`number_${item.value}`]?.percent * 10}%` }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
